var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonitor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.31 16.72H5.19C1.21 16.72 0 15.51 0 11.53V5.19C0 1.21 1.21 0 5.19 0H16.3C20.28 0 21.49 1.21 21.49 5.19V11.52C21.5 15.51 20.29 16.72 16.31 16.72ZM5.19 1.5C2.05 1.5 1.5 2.05 1.5 5.19V11.52C1.5 14.66 2.05 15.21 5.19 15.21H16.3C19.44 15.21 19.99 14.66 19.99 11.52V5.19C19.99 2.05 19.44 1.5 16.3 1.5H5.19Z",
    fill: "#0b8369"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 21.5C10.34 21.5 10 21.16 10 20.75V15.97C10 15.56 10.34 15.22 10.75 15.22C11.16 15.22 11.5 15.56 11.5 15.97V20.75C11.5 21.16 11.16 21.5 10.75 21.5Z",
    fill: "#0b8369"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.75 12.5H0.75C0.34 12.5 0 12.16 0 11.75C0 11.34 0.34 11 0.75 11H20.75C21.16 11 21.5 11.34 21.5 11.75C21.5 12.16 21.16 12.5 20.75 12.5Z",
    fill: "#0b8369"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.25 21.5H6.25C5.84 21.5 5.5 21.16 5.5 20.75C5.5 20.34 5.84 20 6.25 20H15.25C15.66 20 16 20.34 16 20.75C16 21.16 15.66 21.5 15.25 21.5Z",
    fill: "#0b8369"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitor);
export default __webpack_public_path__ + "static/media/monitor.1bf5755b91665272290123dceb25ff8d.svg";
export { ForwardRef as ReactComponent };